import type { ArenaCase, ArenaConfig, ChatTurn, ScamType, StormResult, X402SmokeResult } from "./types";
import type { Locale } from "../i18n";

async function requestJson<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {})
    }
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const message = typeof body?.error === "string" ? body.error : `Request failed: ${res.status}`;
    throw new Error(message);
  }
  return body as T;
}

export function fetchConfig() {
  return requestJson<ArenaConfig>("/api/config");
}

export type CustomCaseRequest = {
  kind: "scam" | "safe";
  prompt: string;
};

export function spawnCase(scamType: ScamType, locale: Locale, budgetUSDC = 0.005, custom?: CustomCaseRequest) {
  return requestJson<ArenaCase>("/api/arena/spawn", {
    method: "POST",
    body: JSON.stringify({ scamType, locale, budgetUSDC, customKind: custom?.kind, customPrompt: custom?.prompt })
  });
}

export function startStorm(size: number, locale: Locale) {
  return requestJson<StormResult>("/api/arena/storm", {
    method: "POST",
    body: JSON.stringify({ size, locale })
  });
}

export function chatWithAgents(message: string, history: ChatTurn[], caseId: string | undefined, locale: Locale) {
  return requestJson<{ answer: string; source: string }>("/api/agent/chat", {
    method: "POST",
    body: JSON.stringify({ message, history, caseId, locale })
  });
}

export function runX402Smoke(locale: Locale) {
  return requestJson<X402SmokeResult>("/api/x402/smoke", {
    method: "POST",
    body: JSON.stringify({ locale })
  });
}
